export {default as default} from './LandingsAccordion'
